import _ from 'lodash';
import moment from 'moment';
import Sugar from 'sugar';
import jsonToQueryParams, * as ToQuery from '../../Components/Common/jsonToQueryParams';
import config from '../../config/index';
import { getStorage, setStorage } from '../../services/Common.services';
import { HTTP } from '../../services/Http.service';
import { customerTypes, DOCUMENT_CUSTOMER, size, trailerTypes } from '../tms/constant';
Sugar.extend();

export function getDocumentType() {
  let url = 'tms/getDocumentTypes';
  return new Promise((resolve, reject) => {
    HTTP('get', url, null, {
      'authorization': getStorage('token'),
    })
      .then((result) => {
        if (result)
          resolve(result.data.data)
      })
      .catch((error) => {
        reject(error);
      });
  })
}

export function getCitiesAndStates() {
  let url = 'tms/getCitiesAndStates';
  return new Promise((resolve, reject) => {
    HTTP('get', url, null, {
      'authorization': getStorage('token'),
    })
      .then((result) => {
        if (result){
          let { cities, states } = result.data.data;
          cities = cities.map((city) => ({ label: city._id, value: city._id }));
          states = states.map((state) => ({ label: state._id, value: state._id }));

          let newCities = [...cities, ...CityOptions];
          let newStates = [...states, ...StatesOptions];

          resolve({ cities: _.uniqBy(newCities, 'label'), states: _.uniqBy(newStates, 'label') })
        }
      })
      .catch((error) => {
        reject(error);
      });
  })

}

export function getCustomerDocumentType(params) {
  return new Promise((resolve, reject) => {
    let DocumentType = []
    DOCUMENT_CUSTOMER.map(d => {

      DocumentType.push({ value: d, label: d })
    })
    resolve(DocumentType)
  })
}

export function uploadLoad(params) {
  let url = 'tms/uploadLoad';
  return new Promise((resolve, reject) => {
    HTTP('post', url, params, {
      'authorization': getStorage('token'),
    })
      .then((result) => {
        if (result)
          resolve(result.data.data)
      })
      .catch((error) => {
        reject(error);
      });
  })
}

export function uploadEdiLoad(params) {
  // let url = "tms/ediAddLoad";
  return new Promise((resolve, reject) => {
    HTTP(
      "post",
      null,
      params,
      {
        authorization: getStorage("token"),
      },
      `${config.ediUrl}edi/ediAddLoad`
    )
      .then((result) => {
        if (result) resolve(result.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function mapData(data) {
  let token = getStorage('token')
  let formData = new FormData();
  formData.append('key', data.key);
  formData.append('id', data.id)
  formData.append('value', data.value)
  formData.append('oldValue', data.oldValue)
  if (!data.value || data.value == null || data.value == 'null') {
    return undefined;
  }
  const response = await HTTP('post', 'tms/mapKeys', formData, {
    authorization: token
  })
  return response;
}

export async function getRossumLoginDetail() {
  let token = getStorage('token')
  let url = 'tms/rossumLoginDetails';
  const response = await HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function rossumAiUpload(data, id, token) {
  let aiToken = `token ${token}`
  let newData = new FormData();
  newData.append('content', data)

  let url = `https://api.elis.rossum.ai/v1/queues/${id}/upload`;
  let response = await HTTP('post', null, newData, {
    authorization: aiToken
  }, url)
  return response;
}

export async function rossumAiListQueue(token, workspace) {
  let aiToken = `token ${token}`

  let url = `https://api.elis.rossum.ai/v1/queues?workspace=${workspace}&ordering=name`;
  const response = await HTTP('get', null, {}, {
    authorization: aiToken
  }, url)
  return response;
}

export async function rossumAiWorkSpace() {
  let token = getStorage('ai')
  let aiToken = `token ${token}`

  let url = 'https://api.elis.rossum.ai/v1/workspaces';
  const response = await HTTP('get', null, {}, {
    authorization: aiToken
  }, url)
  return response;
}
export async function rossumAiEmbed(url, token) {
  let aiToken = `token ${token}`
  let newData = new FormData();
  newData.append('return_url', "https://app.portpro.io/tms/ai")
  newData.append('cancel_url', "https://app.portpro.io/tms/ai")

  let lastUrl = `${url}/start_embedded`;
  const response = await HTTP('post', null, newData, {
    authorization: aiToken
  }, lastUrl)
  return response;
}

export async function rossumAiEmbedPreview(url, token) {
  let aiToken = `token ${token}`
  let newData = new FormData();
  newData.append('return_url', "https://app.portpro.io/tms/ai")
  newData.append('cancel_url', "https://app.portpro.io/tms/ai")

  let lastUrl = `${url}/start_embedded`;
  console.log(lastUrl, 'last url')
  const response = await HTTP('post', null, newData, {
    authorization: aiToken
  }, lastUrl)
  return response;
}
export async function rossumAiConfirm(url, token) {
  let aiToken = `token ${token}`
  let id = url.split('/');
  let annotId = id[id.length - 1];

  let lastUrl = `https://api.elis.rossum.ai/v1/annotations/${annotId}/confirm`;
  const response = await HTTP('post', null, {}, {
    authorization: aiToken
  }, lastUrl)
  return response;
}

export async function rossumeExport(id, token) {
  let aiToken = `token ${token}`

  let lastUrl = `https://api.elis.rossum.ai/v1/annotations/${id}/content`;
  const response = await HTTP('get', null, {}, {
    authorization: aiToken
  }, lastUrl)
  return response;
}


export async function createQue(name, token, workspace) {
  let aiToken = `token ${token}`
  let newData = new FormData();
  newData.append('name', name);
  newData.append('workspace', `https://api.elis.rossum.ai/v1/workspaces/${workspace}`)
  newData.append('schema', 'https://api.elis.rossum.ai/v1/schemas/45513')

  let scheme = `https://api.elis.rossum.ai/v1/schemas/45513`;
  let url = 'https://api.elis.rossum.ai/v1/queues';
  const response = await HTTP('post', null, newData, {
    authorization: aiToken
  }, url)
  return response;
}

export async function rossumAiListSchema() {
  let token = getStorage('ai')
  let aiToken = `token ${token}`

  let url = 'https://api.elis.rossum.ai/v1/schemas';
  const response = await HTTP('get', null, {}, {
    authorization: aiToken
  }, url)
  return response;
}



export function getFleetCustomers(params = {}) {
  let url = 'tms/getTMSFleetCustomers';
  url = params ? url + "?" + jsonToQueryParams(params) : url;
  return new Promise((resolve, reject) => {
    HTTP('get', url, null, {
      'authorization': getStorage('token'),
    })
      .then((result) => {
        const customers = []
        result.data.data.forEach((obj) => {
          customers.push({ value: obj._id, label: obj.company_name });
        })
        resolve(customers);
      })
      .catch((error) => {
        reject(error);
      });
  })
}

export function removeFleetFromCustomer(data) {
  return new Promise((resolve, reject) => {
    HTTP('post', 'tms/removeFleetFromCustomer', data, {
      'authorization': getStorage('token'),
    })
      .then((result) => {
        resolve(result.data)
      })
      .catch((error) => {
        reject(error);
      });
  })
}

export function uploadPdf(data) {
  let newData = new FormData();
  newData.append('document', data)
  return new Promise((resolve, reject) => {
    HTTP('post', 'tms/uploadPdf', newData, {
      'authorization': getStorage('token'),
    })
      .then((result) => {
        resolve(result)
      })
      .catch((error) => {
        reject(error);
      });
  })
}

export async function fetchUsers(url, params) {
  url = params ? url + "?" + jsonToQueryParams(params) : url;
  // url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function getSettings(url) {
  url = 'tms/getSettings';
  const token = tmsToken();
  const response = await HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function getEachDeduction(params) {
  let url = 'tms/deduction';
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function generateCsv(params) {
  let url = 'tms/generateCsv';
  url = params ? url + "?" + ToQuery.objToQueryParams(params) : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}
export function getChargeReport1(params) {
  const token = getStorage("token");
  let fullUrl, url;
  fullUrl = `${config.newDocUrl}report/getChargeReport1`;
  fullUrl = params ? fullUrl + "?" + ToQuery.objToQueryParams(params) : fullUrl;
  return new Promise((resolve, reject) => {
    HTTP("GET", url, params, { authorization: token }, fullUrl)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function downloadChargeReport1(params) {
  const token = getStorage("token");
  let fullUrl, url;
  fullUrl = `${config.newDocUrl}report/downloadChargeReport1Csv`;
  fullUrl = params ? fullUrl + "?" + ToQuery.objToQueryParams(params) : fullUrl;
  return new Promise((resolve, reject) => {
    HTTP("GET", url, params, { authorization: token }, fullUrl)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function getChargeReport2(params) {
  const token = getStorage("token");
  let fullUrl, url;
  fullUrl = `${config.newDocUrl}report/getChargeReport2`;
  fullUrl = params ? fullUrl + "?" + ToQuery.objToQueryParams(params) : fullUrl;
  return new Promise((resolve, reject) => {
    HTTP("GET", url, params, { authorization: token }, fullUrl)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function downloadChargeReport2(params) {
  const token = getStorage("token");
  let fullUrl, url;
  fullUrl = `${config.newDocUrl}report/downloadChargeReport2Csv`;
  fullUrl = params ? fullUrl + "?" + ToQuery.objToQueryParams(params) : fullUrl;
  return new Promise((resolve, reject) => {
    HTTP("GET", url, params, { authorization: token }, fullUrl)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function getChargeReport3(params) {
  const token = getStorage("token");
  let fullUrl, url;
  fullUrl = `${config.newDocUrl}report/getChargeReport3`;
  fullUrl = params ? fullUrl + "?" + ToQuery.objToQueryParams(params) : fullUrl;
  return new Promise((resolve, reject) => {
    HTTP("GET", url, params, { authorization: token }, fullUrl)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function downloadChargeReport3(params) {
  const token = getStorage("token");
  let fullUrl, url;
  fullUrl = `${config.newDocUrl}report/downloadChargeReport3Csv`;
  fullUrl = params ? fullUrl + "?" + ToQuery.objToQueryParams(params) : fullUrl;
  return new Promise((resolve, reject) => {
    HTTP("GET", url, params, { authorization: token }, fullUrl)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function getLoadsReport(params) {
  const token = getStorage("token");
  let fullUrl;
  fullUrl = `${config.newDocUrl}report/getLoadsReport`;
  fullUrl = params ? fullUrl + "?" + ToQuery.objToQueryParams(params) : fullUrl;
  return new Promise((resolve, reject) => {
    HTTP("GET", null, params, { authorization: token }, fullUrl)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function getLoadsReportCsv(params) {
  const token = getStorage("token");
  let fullUrl;
  fullUrl = `${config.newDocUrl}report/getLoadsReportCsv`;
  fullUrl = params ? fullUrl + "?" + ToQuery.objToQueryParams(params) : fullUrl;
  return new Promise((resolve, reject) => {
    HTTP("GET", null, params, { authorization: token }, fullUrl)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function getLoadsPricingReport(params) {
  const token = getStorage("token");
  let fullUrl;
  fullUrl = `${config.newDocUrl}report/getLoadsPricingReport`;
  fullUrl = params ? fullUrl + "?" + ToQuery.objToQueryParams(params) : fullUrl;
  return new Promise((resolve, reject) => {
    HTTP("GET", null, params, { authorization: token }, fullUrl)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function getLoadsPricingReportCsv(params) {
  const token = getStorage("token");
  let fullUrl;
  fullUrl = `${config.newDocUrl}report/getLoadsPricingReportCsv`;
  fullUrl = params ? fullUrl + "?" + ToQuery.objToQueryParams(params) : fullUrl;
  return new Promise((resolve, reject) => {
    HTTP("GET", null, params, { authorization: token }, fullUrl)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function getVesselReport(params) {
  const token = getStorage("token");
  let fullUrl;
  fullUrl = `${config.newDocUrl}report/getVesselReport`;
  fullUrl = params ? fullUrl + "?" + ToQuery.objToQueryParams(params) : fullUrl;
  return new Promise((resolve, reject) => {
    HTTP("GET", null, params, { authorization: token }, fullUrl)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function getVesselReportCsv(params) {
  const token = getStorage("token");
  let fullUrl;
  fullUrl = `${config.newDocUrl}report/getVesselReportCsv`;
  fullUrl = params ? fullUrl + "?" + ToQuery.objToQueryParams(params) : fullUrl;
  return new Promise((resolve, reject) => {
    HTTP("GET", null, params, { authorization: token }, fullUrl)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function searchQbCustomer(params) {
  const obj = { searchTerm: params }

  return new Promise((resolve, reject) => {
    let url = 'tms/searchQbCustomer';
    url = obj ? url + "?" + jsonToQueryParams(obj) : url;
    const token = tmsToken();
    HTTP('get', url, {}, {
      authorization: token
    })
      .then((response) => {
        let customers = [];
        if (response.data.data.QueryResponse && response.data.data.QueryResponse.Customer && response.data.data.QueryResponse.Customer.length > 0) {
          response.data.data.QueryResponse.Customer.forEach((obj) => {
            customers.push({ value: obj.Id, label: obj.DisplayName, allInfos: obj });
          })
        }
        resolve(customers);
      })
  })
}


export function getCustomerQbInvoice(params) {

  return new Promise((resolve, reject) => {
    let url = 'tms/getCustomerQbInvoice';
    url = params ? url + "?" + jsonToQueryParams(params) : url;
    const token = tmsToken();
    HTTP('get', url, {}, {
      authorization: token
    })
      .then((response) => {
        resolve(response);
      })
  })
}

export function getPaymentMethod(params) {

  return new Promise((resolve, reject) => {
    let url = 'tms/getPaymentMethod';
    url = params ? url + "?" + jsonToQueryParams(params) : url;
    const token = tmsToken();
    HTTP('get', url, {}, {
      authorization: token
    })
      .then((response) => {
        resolve(response);
      })
  })
}

export function findAccounts(params) {

  return new Promise((resolve, reject) => {
    let url = 'tms/findAccounts';
    url = params ? url + "?" + jsonToQueryParams(params) : url;
    const token = tmsToken();
    HTTP('get', url, {}, {
      authorization: token
    })
      .then((response) => {
        resolve(response);
      })
  })
}

export function updatePayment(payload) {

  return new Promise((resolve, reject) => {
    let url = 'tms/updatePayment';
    const token = tmsToken();
    HTTP('post', url, payload, {
      authorization: token
    })
      .then((response) => {
        if(response?.data?.data?.errors && response?.data?.data?.errors?.length > 0) {
          const errMsg = response?.data?.data?.errors[0]?.error?.split(":")
          reject(errMsg?.length > 1 ? errMsg[1] : errMsg[0])
        }
        resolve(response);
      })
  })
}

export async function getEachNewDeduction(params) {
  let url = 'tms/new-deduction';
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function addNotes(params) {
  let url = 'tms/addLoadNotes';
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });
  const response = HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export async function getExpense(params) {
  let url = 'tms/getExpense';
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function addExpense(params) {
  let url = 'tms/addExpense';
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });
  const response = HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export async function addExpenseType(params) {
  let url = 'tms/addExpenseType';
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });
  const response = HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export async function addSettlementNotes(params) {
  let url = 'tms/addSettlementNotes';
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });
  const response = HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export async function rotatePdf(params) {
  let url = `${config.docUrl}tms/pdf-rotate`;
  // let url = `${config.docUrl}tms/pdf-rotate`;
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });
  const response = HTTP('post', null, newFormData, {
    authorization: token
  }, url)
  return response;
}

export async function getDriverForDeduction() {
  let url = 'carrier/getDriverForDeduction';
  const token = getStorage('token');
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function getDeduction() {
  let url = 'carrier/deductionType';
  const token = getStorage('token');
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function createTypes(params) {
  let url = 'carrier/createDeductionType';
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });
  const response = HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}


export async function updateDeductionSetting(params) {
  let url = 'carrier/updateDeductionType';
  const token = getStorage('token');
  const timeZone = getStorage('timeZone') ? getStorage('timeZone') : 'UTC';
  const newFormData = new FormData();
  newFormData.append('timeZone', timeZone);
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });
  const response = await HTTP('put', url, newFormData, {
    authorization: token
  })
  return response;
}
export async function updateSettlementSettings(settlementSettings) {
  let url = 'carrier/updateSettlementSettings';
  const newFormData = new FormData();
  const token = getStorage('token');
  newFormData.append('settlementSettings', JSON.stringify(settlementSettings));

  const response = await HTTP('put', url, newFormData, {
    authorization: token
  })
  return response;
}


export async function updateDeduction(params) {
  let url = 'tms/deduction';
  const newFormData = new FormData();
  const token = getStorage('token');
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });

  const response = await HTTP('put', url, newFormData, {
    authorization: token
  })
  return response;
}

export async function updateNewDeduction(params) {
  let url = 'tms/new-deduction';
  const newFormData = new FormData();
  const token = getStorage('token');
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });

  const response = await HTTP('put', url, newFormData, {
    authorization: token
  })
  return response;
}

export async function updateProfile(params) {
  let url = 'carrier/updateDriverProfile';
  const newFormData = new FormData();
  const token = getStorage('token');
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });

  const response = await HTTP('put', url, newFormData, {
    authorization: token
  })
  return response;
}



export async function getAllSettlements(params) {
  let url = 'tms/settlement';
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}


export async function getAllNewSettlements(params) {
  params= _.omitBy(params, _.isNil);
  let url = 'tms/new-settlement';
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function getSettlementsForDriver(params) {
  let url = 'tms/getSettlementsForDriver';
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export const tmsToken = function () {
  const token = getStorage('token');
  return token;
}

export async function fetchPricing(params) {
  let url = 'tms/load-priceCalc';
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = await HTTP('get', url, {}, {
    authorization: token
  });
  return response;
}

export async function editLoad(data) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(data).forEach((key) => {
    if (['pricing', 'shipper', 'consignee', 'items'].indexOf(key) > -1) {
      newFormData.append(key, JSON.stringify(data[key]));
    } else {
      newFormData.append(key, data[key]);
    }
  });

  const response = await HTTP('post', 'tms/editLoad', newFormData, {
    authorization: token
  })
  return response;

}
export async function removeValueLoad(data) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(data).forEach((key) => {
    if (['pricing', 'shipper', 'consignee'].indexOf(key) > -1) {
      newFormData.append(key, JSON.stringify(data[key]));
    } else {
      newFormData.append(key, data[key]);
    }
  });

  const response = await HTTP('post', 'tms/removeValueLoad', newFormData, {
    authorization: token
  })
  return response;
}

export async function saveLoadNotes(data) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(data).forEach((key) => {
    newFormData.append(key, data[key]);
  });
  
  const response = await HTTP('post', 'tms/saveLoadNotes', newFormData, {
    authorization: token
  })
  return response;
}

export async function createLoad(data) {
  const newFormData = new FormData();
  let url = 'tms/addLoad'
  const token = getStorage('token')
  if (getStorage('currentUserRole') == 'customer') {
    url = 'tms/addLoadForCustomer';
  }
  Object.keys(data).forEach((key) => {
    if (['pricing', 'shipper', 'consignee', 'customerEmployee'].indexOf(key) > -1) {
      newFormData.append(key, JSON.stringify(data[key]));
    } else {
      newFormData.append(key, data[key]);
    }
  });
  const response = await HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export async function deleteEquipmentDoc(data) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(data).forEach((key) => {
    newFormData.append(key, data[key]);
  });

  const response = await HTTP('post', 'carrier/deleteEquipmentDoc', newFormData, {
    authorization: token
  })
  return response;
}

export async function deleteChassisDoc(data) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(data).forEach((key) => {
    newFormData.append(key, data[key]);
  });

  const response = await HTTP('post', 'carrier/deleteChassisDoc', newFormData, {
    authorization: token
  })
  return response;
}

export async function deleteDriverDoc(data) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(data).forEach((key) => {
    newFormData.append(key, data[key]);
  });

  const response = await HTTP('post', 'carrier/deleteDriverDoc', newFormData, {
    authorization: token
  })
  return response;
}

export async function deleteCustomerDoc(data) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(data).forEach((key) => {
    newFormData.append(key, data[key]);
  });

  const response = await HTTP('post', 'carrier/deleteCustomerDoc', newFormData, {
    authorization: token
  })
  return response;
}

export async function printSelected(docs) {
  const token = getStorage('token');
  const response = await HTTP('post', null, {docs : docs}, {
    authorization: token
  }, `${config.docUrl}selectedDocumentDownload`)
  return response;
}

export async function getLoad(params) {
  const token = getStorage('token');
  let url = 'tms/getLoads';
  // url = params ? url + "?" + ToQuery.objToQueryParams(params) : url;
  const response = await HTTP('post', url, params, {
    authorization: token
  })
  return response;
}

export async function getAllUsers(params) {
  const token = getStorage('token');
  let url = 'tms/getAllTmsCustomers';
  url = params ? url + "?" + ToQuery.objToQueryParams(params) : url;
  const response = await HTTP('get', url, {}, {
    authorization: token
  });
  return response;
}

export async function getMasterTermsBySearch(params) {
  const token = getStorage('token');
  let url = 'tms/masterSearchTms';
  url = params ? url + "?" + ToQuery.objToQueryParams(params) : url;
  const response = await HTTP('get', url, {}, {
    authorization: token
  });
  return response;
}

export async function AddProfile(url, data) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(data).forEach((key) => {
    if (['address', 'customerType', 'emailStatuses', 'newTerminal'].indexOf(key) > -1) {
      newFormData.append(key, JSON.stringify(data[key]));
    } else {
      newFormData.append(key, data[key]);
    }
  });
  const response = await HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export async function UpdatePricing(url, data) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(data).forEach((key) => {
    if (key == 'items' || key == "pricing") {
      newFormData.append(key, JSON.stringify(data[key]));
    } else {
      newFormData.append(key, data[key]);
    }
  });
  const response = await HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export async function removeLoad(_id, isEnable) {
  const newFormData = new FormData();
  const token = getStorage('token')
  newFormData.append('_id', _id);
  if (isEnable) {
    newFormData.append('isEnable', isEnable);
  }
  const response = await HTTP('post', 'tms/removeLoad', newFormData, {
    authorization: token
  })
  return response;
}

export async function getContainerSize() {
  const token = getStorage('token')
  const response = await HTTP('get', 'admin/getContainerSize', null, {
    authorization: token
  })
  return response;
}

export async function getContainerType() {
  const token = getStorage('token')
  const response = await HTTP('get', 'admin/getContainerType', null, {
    authorization: token
  })
  return response;
}

export async function getTMSContainerOwner(params) {
  const token = getStorage('token')
  let url = 'carrier/getTMSContainerOwner';
  url = params ? url + "?" + jsonToQueryParams(params) : url;
  const response = await HTTP('get', url, null, {
    authorization: token
  })
  return response;
}

export async function getChassisSize(params) {
  const token = getStorage('token');
  let url = 'admin/getChassisSize';
  url = params ? url + "?" + jsonToQueryParams(params) : url;
  const response = await HTTP('get', url, null, {
    authorization: token
  })
  return response;
}

export async function getChassisType(params) {
  const token = getStorage('token');
  let url = 'admin/getChassisType';
  url = params ? url + "?" + jsonToQueryParams(params) : url;
  const response = await HTTP('get', url, null, {
    authorization: token
  })
  return response;
}
export async function getCustomerNotification() {
  const token = getStorage('token')
  const response = await HTTP('get', 'tms/getNotifications', null, {
    authorization: token
  })
  return response;
}
export async function getTMSChassisOwner(params) {
  const token = getStorage('token');
  let url = 'carrier/getTMSChassisOwner';
  url = params ? url + "?" + jsonToQueryParams(params) : url;
  const response = await HTTP('get', url, null, {
    authorization: token
  })
  return response;
}

export async function changeLoadStatus(params) {
  const token = getStorage('token')
  const response = await HTTP('post', 'tms/changeLoadStatus', params, {
    authorization: token
  })
  return response;
}

export async function addPaymentTMSLoad(params) {
  const token = getStorage('token')
  const response = await HTTP('post', 'tms/addPaymentTMSLoad', params, {
    authorization: token
  });
  return response;
}
export async function removePaymentTMSLoad(params) {
  const token = getStorage('token')
  const response = await HTTP('post', 'tms/removePaymentTMSLoad', params, {
    authorization: token
  });
  return response;
}

// should be doc server

export async function downLoadSettlementPDF(params) {
  const token = getStorage('token')
  const response = await HTTP('post', null, params, {
    authorization: token
  }, `${config.docUrl}tms/generateSattlementPdf`);

  return response;
}
// should be doc server

export async function downloadAllSettlement(params) {
  const token = getStorage('token')
  const response = await HTTP('post', null, params, {
    authorization: token
  }, `${config.docUrl}tms/generateAllSettlement`);

  return response;
}

// should be doc server

export async function sendSettlementPdf(params) {
  const token = getStorage('token')
  const response = await HTTP('post', null, params, {
    authorization: token
  }, `${config.docUrl}tms/sendSettlementPdf`);

  return response;
}

// should be doc server

export async function sendBillingEmail(params) {
  const token = getStorage('token')
  const response = await HTTP('post', null, params, {
    authorization: token
  }, `${config.docUrl}tms/sendEmailDocumentOfLoad`);
  return response;
}
export async function downloadLambdaDocument(params) {
  const token = getStorage('token')
  const response = await HTTP('post', null, params, {
    authorization: token,
    'Content-Type': 'application/json'
  }, `${config.pdfUrl}download`);
  return response;
}

export async function UpdateExpense(url, data) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(data).forEach((key) => {
    if (key == "expense") {
      newFormData.append(key, JSON.stringify(data[key]));
    } else {
      newFormData.append(key, data[key]);
    }
  });
  const response = await HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

// should be doc server
export async function sendMultileDocToCustomerEmail(params) {
  const token = getStorage('token')
  const response = await HTTP('post', null, params, {
    authorization: token,
    'Content-Type': 'application/json'
  }, `${config.pdfUrl}sendEmail`);
  return response;
}

export async function sendEmailDocumentOfQuotes(params) {
  const token = getStorage('token');
  let url, fullUrl;
  fullUrl = `${config.docUrl}tms/sendEmailDocumentOfQuotes`;
  const response = await HTTP(
    "post",
    url,
    params,
    {
      authorization: token,
    },
    fullUrl
  );
  return response;
}

export async function generateAgingReportNew(params) {
  const token = getStorage('token')
  let url, fullUrl;
  if(params?.isPdf){
    fullUrl = `${config.newDocUrl}report/getAgingReport1DownloadPdf`;
    delete params.isPdf;
    fullUrl = Object.keys(params)?.length>0? fullUrl + "?" + Object.entries(params).map(e => e.join('=')).join('&'):fullUrl;
  }else{
    fullUrl = `${config.newDocUrl}report/getAgingReport1`;
  }
  const response = await HTTP('get', url, params, {
    authorization: token
  }, fullUrl);
  return response;
}





export async function sendMultileDocToSubCustomerEmail(params) {
  let fullUrl = `${config.newDocUrl}tms/generateInvoiceSubCustomerWisePricingLoad`;
  const token = getStorage('token')
  const response = await HTTP('post', null, params, {
    authorization: token
  }, fullUrl);
  return response;
}

export async function duplicateLoad(params) {
  const token = getStorage('token')
  const response = await HTTP('post', 'tms/duplicateLoad', params, {
    authorization: token
  });
  return response;
}

export async function saveFreeDay(params) {
  const token = getStorage('token')
  const response = await HTTP('post', 'tms/addFreeContainerReturn', params, {
    authorization: token
  });
  return response;
}

export async function getsaveFreeDay() {
  const token = getStorage('token')
  const response = await HTTP('get', 'tms/freeReturnInfos', null, {
    authorization: token
  })
  return response;
}

export async function getDriverLocationHistoryByLoad(params) {
  let url = 'tms/getDriverLocationHistoryByLoad';
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = await HTTP('get', url, {}, {
    authorization: token
  });
  return response;
}
export async function getRouteBetweenLocations(params) {
  let url = 'tms/getRouteBetweenLocations';
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = await HTTP('get', url, {}, {
    authorization: token
  });
  return response;
}

export async function manualDriverPay(params) {
  const token = getStorage('token')
  const response = await HTTP('post', 'tms/manualDriverPay', params, {
    authorization: token
  });
  return response;
}

export async function driverPaymentByType(params) {
  const token = getStorage('token')
  const response = await HTTP('post', 'tms/driver-payment-by-type', params, {
    authorization: token
  });
  return response;
}



export async function getDriverPaymentByType(params) {
  let url = 'tms/get-driver-payment-by-type';
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = getStorage('token')
  const response = await HTTP('get', url, {}, {
    authorization: token
  });
  return response;

}

export async function manualNewDriverPay(params) {
  const token = getStorage('token')
  const response = await HTTP('post', 'tms/new-manualDriverPay', params, {
    authorization: token
  });
  return response;
}

export async function changeStatus(statusObj) {
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(statusObj).forEach((key) => {
    newFormData.append(key, statusObj[key]);

  });
  const response = await HTTP('put', 'tms/settlement-update', newFormData, {
    authorization: token
  });
  return response;
}

export async function changeNewStatus(statusObj) {
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(statusObj).forEach((key) => {
    newFormData.append(key, statusObj[key]);

  });
  const response = await HTTP('put', 'tms/new-settlement-update', newFormData, {
    authorization: token
  });
  return response;
}

export async function addTerminal(params) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(params).forEach((key) => {
    if (['address'].indexOf(key) > -1) {
      newFormData.append(key, JSON.stringify(params[key]));
    } else {
      newFormData.append(key, params[key]);
    }
  });
  const response = await HTTP('post', 'addTerminal', newFormData, {
    authorization: token
  });
  return response;
}

export async function getTerminal(params, isFleetmanagerSpecific=true) {
  let url = 'getTerminal';
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const newFormData = new FormData();
  const token = getStorage('token')
  let response = await HTTP('get', url, {}, {
    authorization: token
  });
  if (response && response.data && response.data.data.length > 0 && isFleetmanagerSpecific) {
    if (getStorage('currentUserRole') == 'fleetmanager' && (config.idForTerminal.indexOf(JSON.parse(getStorage('loggedInUser')).fleetManager.carrier) != -1)) {
      let fleetTerminal = JSON.parse(getStorage('loggedInUser')).fleetManager.terminals;
      response.data.data = response.data.data.filter((D) => fleetTerminal.indexOf(D._id) > -1);
    }
  }
  return response;
}

export async function deleteTerminal(params) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(params).forEach((key) => {
    if(key === 'address') {
      newFormData.append(key, JSON.stringify(params[key]));
    } else {
      newFormData.append(key, params[key]);
    }
  });
  const response = await HTTP('post', 'addTerminal', newFormData, {
    authorization: token
  });
  return response;
}

export async function updateLocationPrice(params) {
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys(params).forEach((key) => {
    if (key == 'amounts') {
      newFormData.append(key, JSON.stringify(params[key]));
    } else {
      newFormData.append(key, params[key]);
    }
  });
  const response = await HTTP('post', 'tms/driver-payment-status', newFormData, {
    authorization: token
  });
  return response;
}

export async function getPending(params) {
  let url = 'tms/getPendingDeduction'
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function getNewPending(params) {
  let url = 'tms/getNewPendingDeduction'
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function getLoadCounts(params) {
  let url = 'tms/getLoadCounts'
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export function getTMSLoadCounts(params) {
  let url = 'tms/getTMSLoadCounts';
  // url = params ? url + "?" + ToQuery.objToQueryParams(params) : url;
  const token = tmsToken();
  const response = HTTP('post', url, params, {
    authorization: token
  })
  return response;
}

export function getTMSLoadsByOptions(params) {
  let url = 'tms/getTMSLoadsByOptions'
  // url = params ? url + "?" + ToQuery.objToQueryParams(params) : url;

  const token = tmsToken();
  const response = HTTP('post', url, params, {
    authorization: token
  })
  return response;
}

export async function AddSettlement(params) {
  let url = 'tms/settlement';
  const newFormData = new FormData();
  const token = getStorage('token')
  Object.keys((params)).forEach((ke) => {
    newFormData.append(ke, params[ke]);
  });
  const response = HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export const colorStatusBased = function (status) {
  let color = 'red';
  if (status === 'PENDING') {
    color = '#ff8099';
  } else if (status === 'AVAILABLE') {
    color = '#bed96c';
  } else if (status === 'DROPCONTAINER_DEPARTED') {
    color = '#c791d9';
  } else {
    color = '#A5DB03';
  }
  return color
}

export const renderColor = (date) => {
  let style = 'td_span ';
  if (date && date != '' && date != undefined) {

    if (moment(date).diff(moment(), 'days') < 0) {
      style = 'bg-warning-500 text-center'
    } else if (moment(date).diff(moment(), 'days') === 0) {
      style = 'bg-warning-200 text-center'
    } else if (moment(date).diff(moment(), 'days') >= 1 && moment(date).diff(moment(), 'days') <= 2) {
      style = 'td_span btn-cyan '
    }
  }
  return style;
}

export const formatDateFreeDay = (date) => {
  if (date) {
    return moment(date).tz(getStorage('timeZone')).format('MM/DD');
  } else {
    return ''
  }
}

export const formatToDateAndTime = (date) => {
  if (date) {
    return moment(date).tz(getStorage('timeZone')).format('MM/DD HH:mm');
  } else {
    return ''
  }
}

export const deleteDriverPay = (params) => {
  let url = 'tms/delete-driver-pay';
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });
  const response = HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export const deleteNewDriverPay = (params) => {
  let url = 'tms/new-delete-driver-pay';
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });
  const response = HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export const deleteDocument = (params) => {
  let url = 'tms/delete-document';
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });
  const response = HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export const updateDocument = (params) => {
  let url = 'tms/update-document';
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });
  const response = HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export const onBoardingDone = (params) => {
  let url = 'tms/setOnboardingDone';
  const token = getStorage('token');
  const newFormData = new FormData();
  Object.keys(params).forEach((key) => {
    newFormData.append(key, params[key]);
  });
  const response = HTTP('post', url, newFormData, {
    authorization: token
  })
  return response;
}

export async function UpdateAdditionalPricing(data) {
  const newFormData = new FormData();
  newFormData.append('reference_number', data.reference_number);
  newFormData.append('additionalPricing', JSON.stringify(data.additionalPricing));
  const token = getStorage('token');
  const response = await HTTP('post', 'tms/updateAdditionalPricingLoad', newFormData, {
    authorization: token
  })
  return response;
}

export async function getLoadByOverView(params) {
  let url = 'tms/getLoadByOverView'
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function getEquipmentHistory(params) {
  let url = 'tms/getEquipmentHistory'
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function getChassisHistory(params) {
  let url = 'tms/v2/getChassisHistory'
  url = params ? url + "?" + Object.entries(params).map(e => e.join('=')).join('&') : url;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export function getTrailers(sParams = {}) {
  const params = {
    equipment_type: "TRAILER",
    ...sParams
  }
  let url = 'carrier/getTMSEquipments';
  url = params ? url + "?" + jsonToQueryParams(params) : url;
  return new Promise((resolve, reject) => {
    HTTP('GET', url, null, {
      'authorization': getStorage('token'),
    })
      .then((result) => {
        const data = []
        result.data.data.forEach((obj) => {
          data.push({ value: obj.equipmentID, label: obj.equipmentID, allInfo: obj })
        })
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  })
}

export function getTrailerTypes() {
  return new Promise((resolve, reject) => {
    const data = []
    trailerTypes.forEach((obj) => {
      data.push({ value: obj, label: obj })
    })
    resolve(data);
  })
}

export function getTrailerSizes() {
  return new Promise((resolve, reject) => {
    const data = []
    size.forEach((obj) => {
      data.push({ value: obj, label: obj })
    })
    resolve(data);
  })
}

export function getCustomerTypes() {
  return new Promise((resolve, reject) => {
    resolve(customerTypes);
  })
}

export async function getLoadPricingSettings(params) {
  let url = `tms/getLoadPricingSettings`;
  if(params.isDownload && params.isDownload == true) {
    const token = getStorage("token");
    let fullUrl = `${config.newDocUrl}` + url;
    const response = HTTP('post', null, params, {
      authorization: token
    },fullUrl)
    return response;
  } else {
    const token = tmsToken();
    const response = HTTP('post', url, params, {
      authorization: token
    })
    return response;
  }
}

export async function getQuotePricing(params) {
  let url = `tms/getQuotePricing`;
  const token = tmsToken();
  const response = HTTP('post', url, params, {
    authorization: token
  })
  return response;
}
export async function getCustomerDiscountSettings(params) {
  let url = `tms/getCustomerDiscountSettings`;
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function addLoadPricingSettings(params) {
  let url = 'tms/addLoadPricingSettings'
  const token = tmsToken();
  const response = HTTP('post', url, params, {
    authorization: token
  })
  return response;
}
export async function addCustomerDiscountSettings(params) {
  let url = 'tms/addCustomerDiscountSettings'
  const token = tmsToken();
  const response = HTTP('post', url, params, {
    authorization: token
  })
  return response;
}

export async function removeLoadPricingSettings(params) {
  let url = 'tms/removeLoadPricingSettings'
  const token = tmsToken();
  const response = HTTP('post', url, params, {
    authorization: token
  })
  return response;
}

export async function removeCustomerDiscountSettings(params) {
  let url = 'tms/removeCustomerDiscountSettings'
  const token = tmsToken();
  const response = HTTP('post', url, params, {
    authorization: token
  })
  return response;
}

export async function getLoadQuoteSettings(params) {
  let url = 'tms/getLoadQuoteSettings'
  if(params) {
    url = params ? `${url}?${ToQuery.objToQueryParams(params)}` : url;
  }
  const token = tmsToken();
  const response = HTTP('get', url, {}, {
    authorization: token
  })
  return response;
}

export async function addLoadQuoteSettings(params) {
  const token = tmsToken();
  let url, fullUrl;
  fullUrl = `${config.docUrl}tms/addLoadQuoteSettings`;
  const response = await HTTP(
    "post",
    url,
    params,
    {
      authorization: token,
    },
    fullUrl
  );
  return response;
}

export async function removeLoadQuoteSettings(params) {
  let url = 'tms/removeLoadQuoteSettings'
  const token = tmsToken();
  const response = HTTP('post', url, params, {
    authorization: token
  })
  return response;
}

export async function getPriceBreakdown(params) {
    let url = `${config.newDocUrl}report/getPriceBreakdown`;
    url = params ? url + "?" + ToQuery.objToQueryParams(params) : url;
    const token = tmsToken();
    const response = HTTP('get', null, {}, {
      authorization: token
    },url)
    return response;
}

export async function getPriceBreakdownCsv(params) {
    let url = `${config.newDocUrl}report/getPriceBreakdownCsv`;
    url = params ? url + "?" + ToQuery.objToQueryParams(params) : url;
    const token = tmsToken();
    const response = HTTP('get', null, {}, {
      authorization: token
    },url)
    return response;
  
}

export function simplifyLocation(location) {
  let finalLocation;
  if (location.indexOf(',') != -1) {
    let locationArray = location.split(',');
    locationArray = locationArray.unique();
    finalLocation = locationArray.join(',');
  } else {
    finalLocation = location;
  }
  return finalLocation;
}

export async function getSummaryReport(params) {
  let url = `${config.newDocUrl}report/getSummaryReport`;
  url = params ? url + "?" + ToQuery.objToQueryParams(params) : url;
  const token = tmsToken();
  const response = HTTP('get', null, {}, {
    authorization: token
  },url)
  return response;

}
export async function getSummaryReportCsv(params) {
  let url = `${config.newDocUrl}report/getSummaryReportCsv`;
  url = params ? url + "?" + ToQuery.objToQueryParams(params) : url;
  const token = tmsToken();
  const response = HTTP('get', null, {}, {
    authorization: token
  },url)
  return response;

}
export async function getLoadCountCsv(params) {
  let url = `${config.newDocUrl}report/getLoadCountCsv`;
  url = params ? url + "?" + ToQuery.objToQueryParams(params) : url;
  const token = tmsToken();
  const response = HTTP('get', null, {}, {
    authorization: token
  },url)
  return response;

}
export async function getLoadCount(params) {
  let url = `${config.newDocUrl}report/getLoadCount`;
  url = params ? url + "?" + ToQuery.objToQueryParams(params) : url;
  const token = tmsToken();
  const response = HTTP('get', null, {}, {
    authorization: token
  },url)
  return response;

}

export function renderStatues(status) {
  if (!status) {
    return '';
  }
  let statues = [{
    key: 'Vessel Arrived',
    value: 'Vessel Arrived'
  },
  {
    key: 'Carrier Release',
    value: 'Carrier Released',
  },
  {
    key: 'Carrier Released',
    value: 'Carrier Released',
  },
  {
    key: 'Carried Released',
    value: 'Carrier Released'
  },
  {
    key: 'Container in transit for import',
    value: 'Vessel Departed'
  },
  {
    key: '',
    value: ''
  },
  {
    key: 'Container is available to be released / delivered',
    value: 'Available'
  },
  {
    key: 'Container to consignee',
    value: 'Outgated'
  },
  {
    key: 'Container was discharged at Port of Destination',
    value: 'Discharged'
  },
  {
    key: 'Container was loaded at Port of Loading to Port of Discharge',
    value: 'Vessel Departed'
  },
  {
    key: 'Customs and Carrier Release',
    value: 'Customs & Carrier Release'
  },
  {
    key: 'Customs Release',
    value: 'Customs Release'
  },
  {
    key: 'Departed  for',
    value: 'Vessel Departed'
  },
  {
    key: 'Departure from',
    value: 'Vessel Departed'
  },
  {
    key: 'DISCHARG',
    value: 'Discharged'
  },
  {
    key: 'Discharge',
    value: 'Discharged'
  },
  {
    key: 'Discharged (FCL)',
    value: 'Discharged'
  },

  {
    key: 'Discharged at Last POD',
    value: 'Discharged'
  },
  {
    key: 'Discharged from vessel',
    value: 'Discharged'
  },
  {
    key: 'Discharged',
    value: 'Discharged'
  },
  {
    key: 'Empty container returned from Customer',
    value: 'Empty Returned'
  },
  {
    key: 'Empty container returned',
    value: 'Empty Returned'
  },
  {
    key: 'Empty Equipment Returned',
    value: 'Empty Returned'
  },
  {
    key: 'Empty in Container Yard',
    value: 'Empty Returned'
  },
  {
    key: 'Empty out for booking',
    value: 'Empty Out For Booking'
  },
  {
    key: 'Empty Returned',
    value: 'Empty Returned'
  },
  {
    key: 'Estimated vessel departure',
    value: 'Vessel Departed'
  },
  {
    key: 'Gate in empty',
    value: 'Ingate'
  },
  {
    key: 'Gate Out from Inbound Terminal for Delivery to Consignee (or Port Shuttle)',
    value: 'Outgated'
  },
  {
    key: 'Gate Out from Inbound Terminal for Delivery to Consignee',
    value: 'Outgated'
  },
  {
    key: 'Gate Out Full',
    value: 'Outgated'
  },
  {
    key: 'Gate-out from Final Hub',
    value: 'Outgated'
  },
  {
    key: 'GATE-OUT',
    value: 'Outgated'
  },
  {
    key: 'Import truck departure from Port of Discharge to Customer',
    value: 'Outgated'
  },
  {
    key: 'LOAD',
    value: 'Loaded On Vessel'
  },
  {
    key: 'Loaded at First POL',
    value: 'Loaded On Vessel'
  },
  {
    key: 'Loaded at T/S POL',
    value: 'Loaded On Vessel'
  },
  {
    key: 'Loaded full on vessel',
    value: 'Loaded On Vessel'
  },
  {
    key: 'MovementDischarged from vessel',
    value: 'Container Discharged'
  },
  {
    key: 'MovementEmpty container returned',
    value: 'Container Discharged'
  },
  {
    key: 'Transship container loaded on outbound vessel',
    value: 'Loaded On Vessel'
  },
  {
    key: 'MovementVessel arrived',
    value: 'Vessel Arrived'
  },
  {
    key: 'MovementVessel departed',
    value: 'Vessel Departed'
  },
  {
    key: 'MovementVessel departed from transshipment location',
    value: 'Vessel Departed'
  },
  {
    key: 'On Board',
    value: 'Loaded On Vessel'
  },
  {
    key: 'Loaded full on',
    value: 'Loaded On Vessel'
  },
  {
    key: 'Loaded on board',
    value: 'Loaded On Vessel'
  },
  {
    key: 'Loaded',
    value: 'Loaded On Vessel'
  },
  {
    key: 'On Board (Transit)',
    value: 'Vessel Departed'
  },
  {
    key: 'On Board',
    value: 'Vessel Departed'
  },
  {
    key: 'Picked Up for Delivery',
    value: 'Outgated'
  },
  {
    key: 'Transship container loaded on outbound',
    value: 'Vessel Departed'
  },
  {
    key: 'Transshipment Loaded',
    value: 'Loaded On Vessel'
  },
  {
    key: 'Unloaded from Vessel at Port of Discharging',
    value: 'Unloaded From Vessel'
  },
  {
    key: 'Unloaded from Vessel at Transhipment Port',
    value: 'Unloaded From Vessel'
  },
  {
    key: 'Vessel arrival to Port of Discharge',
    value: 'Vessel Arrived'
  },
  {
    key: 'Vessel arrival',
    value: 'Vessel Arrived'
  },
  {
    key: 'Vessel Arrived',
    value: 'Vessel Arrived'
  },
  {
    key: 'Vessel Berthed',
    value: 'Vessel Arrived'
  },
  {
    key: 'Vessel departed from transshipment location',
    value: 'Vessel Departed'
  },
  {
    key: 'Vessel Departed',
    value: 'Vessel Departed'
  },
  {
    key: 'Vessel Departure from Port of Loading',
    value: 'Vessel Departed'
  },
  {
    key: 'Vessel departure from Transshipment Port to Port of Discharge',
    value: 'Vessel Departed'
  },
  {
    key: 'Vessel Depature from Transhipment Port',
    value: 'Vessel Departed'
  },
  {
    key: 'Vessel POD Berthing Destination',
    value: 'Vessel Arrived'
  }
  ]

  let foundStatus = null;
  let textLength = 0;
  let indexSearchedText = null;
  statues.forEach((eachStatus, key) => {
    if (eachStatus.key.toLowerCase() == status.toLowerCase()) {
      foundStatus = eachStatus.value;
    }
    if (!foundStatus && status.toLowerCase().indexOf(eachStatus.key.toLowerCase()) != -1 && eachStatus.key.length > textLength) {
      indexSearchedText = eachStatus.value;
      textLength = eachStatus.key.length;
    };
  })
  let simplifiedText;
  if (foundStatus) {
    simplifiedText = foundStatus
  } else if (!foundStatus && indexSearchedText) {
    simplifiedText = indexSearchedText
  } else {
    simplifiedText = status;
  }
  return simplifiedText;

}

export async function acceptLoad(_id, accept) {
  const token = getStorage('token')
  const newFormData = new FormData();
  newFormData.append('_id', _id)
  newFormData.append('accept', accept)
  const response = await HTTP('post', 'tms/acceptLoad', newFormData, {
    authorization: token
  });
  return response;
}

export function getFleetManagersByCustomerId(params) {

  return new Promise((resolve, reject) => {
    let url = 'carrier/getFleetManagersByCustomerId';
    url = params ? url + "?" + jsonToQueryParams(params) : url;
    const token = tmsToken();
    HTTP('get', url, {}, {
      authorization: token
    })
      .then((response) => {
        resolve(response);
      })
  })
}

export function SettlementSetting() {
  let startDate = moment().tz(getStorage('timeZone')).startOf('weeks').toISOString();
  let endDate = moment().tz(getStorage('timeZone')).endOf('weeks').toISOString();
  // if (getStorage('currentUserRole') == 'fleetmanager' && JSON.parse(getStorage('loggedInUser')).fleetManager._id == "5ee790f864ca3551b0245d34") {
  //   let dayName = moment().tz(getStorage('timeZone')).format('ddd').toLowerCase();
  //   if (['sun', 'mon', 'tue'].indexOf(dayName) != -1) {
  //     startDate = moment().tz(getStorage('timeZone')).add(-1, 'weeks').startOf('weeks').add(3, 'days').startOf('days').toISOString();
  //     endDate = moment().tz(getStorage('timeZone')).add(-1, 'weeks').endOf('weeks').add(3, 'days').endOf('days').toISOString();
  //   } else {
  //     startDate = moment().tz(getStorage('timeZone')).startOf('weeks').add(3, 'days').startOf('days').toISOString();
  //     endDate = moment().tz(getStorage('timeZone')).endOf('weeks').add(3, 'days').endOf('days').toISOString();
  //   }
  //   // startDate = moment()..tz(getStorage('timeZone')).add(2,'days').endOf('days').toISOString();
  //   // endDate = moment(endDate).tz(getStorage('timeZone')).add(2,'days').endOf('days').toISOString();
  // }
  // if (getStorage('currentUserRole') == 'carrier' && JSON.parse(getStorage('loggedInUser'))._id == "5ee790f864ca3551b0245d34") {
  //   let dayName = moment().tz(getStorage('timeZone')).format('ddd').toLowerCase();
  //   if (['sun', 'mon', 'tue'].indexOf(dayName) != -1) {
  //     startDate = moment().tz(getStorage('timeZone')).add(-1, 'weeks').startOf('weeks').add(3, 'days').startOf('days').toISOString();
  //     endDate = moment().tz(getStorage('timeZone')).add(-1, 'weeks').endOf('weeks').add(3, 'days').endOf('days').toISOString();
  //   } else {
  //     startDate = moment().tz(getStorage('timeZone')).startOf('weeks').add(3, 'days').startOf('days').toISOString();
  //     endDate = moment().tz(getStorage('timeZone')).endOf('weeks').add(3, 'days').endOf('days').toISOString();
  //   }
  // }
  if (getStorage('currentUserRole') == 'fleetmanager' && JSON.parse(getStorage('loggedInUser'))._id == "5f510f0ce26c7543e2800f8b") {
    let dayName = moment().tz(getStorage('timeZone')).format('ddd').toLowerCase();
    if (["sun", "mon", "tue", "wed", "thu", "fri"].indexOf(dayName) != -1) {
      startDate = moment().tz(getStorage('timeZone')).add(-1, 'weeks').startOf('weeks').add(7, 'days').startOf('days').toISOString();
      endDate = moment().tz(getStorage('timeZone')).endOf('weeks').add(-1, 'days').endOf('days').toISOString();
    } else {
      startDate = moment().tz(getStorage('timeZone')).toISOString();
      endDate = moment().tz(getStorage('timeZone')).add(1, 'weeks').endOf('weeks').add(-1, 'days').endOf('days').toISOString();
    }
    // startDate = moment()..tz(getStorage('timeZone')).add(2,'days').endOf('days').toISOString();
    // endDate = moment(endDate).tz(getStorage('timeZone')).add(2,'days').endOf('days').toISOString();
  }
  if (getStorage('currentUserRole') == 'carrier' && JSON.parse(getStorage('loggedInUser'))._id == "5f510f0ce26c7543e2800f8b") {
    let dayName = moment().tz(getStorage('timeZone')).format('ddd').toLowerCase();
    if (["sun", "mon", "tue", "wed", "thu", "fri"].indexOf(dayName) != -1) {
      startDate = moment().tz(getStorage('timeZone')).add(-1, 'weeks').startOf('weeks').add(7, 'days').startOf('days').toISOString();
      endDate = moment().tz(getStorage('timeZone')).endOf('weeks').add(-1, 'days').endOf('days').toISOString();
    } else {
      startDate = moment().tz(getStorage('timeZone')).toISOString();
      endDate = moment().tz(getStorage('timeZone')).endOf('weeks').add(-1, 'days').endOf('days').toISOString();
    }
  }
  return {
    startDate,
    endDate
  }
}

// HTTP(method, uri, data, headers = null, fullUrl)
//  http://localhost:8081/tms/getFtpOrder
export function getTenderLoads(params) {
  // let url = "edi/getTenderedLoads";
  // console.log("sdafsdfsdfsdf", getStorage("token"));
  return new Promise((resolve, reject) => {
    HTTP("post", null, params, {
      authorization: getStorage("token"),
    },  `${config.ediUrl}edi/getTenderedLoads`,)
      .then((result) => {
        if (result) resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getFtpOrderWithWorkOrders(params) {
  let url = "tms/getFtpOrderWithWorkOrders";
  return new Promise((resolve, reject) => {
    HTTP("post", url, params, {
      authorization: getStorage("token"),
    })
      .then((result) => {
        if (result) resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getEdiAudits(params) {
  let url = config.ediUrl + 'edi/getEdiAudits';
  return new Promise((resolve, reject) => {
      HTTP('post', null, params, {
          'authorization': getStorage('token'),
      }, url)
      .then((result) => {
      resolve(result);
      })
      .catch((error) => {
      reject(error);
      });
  })
}
export const StatesOptions = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AS", label: "American Samoa" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District of Columbia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "GU", label: "Guam" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "PR", label: "Puerto Rico" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "VI", label: "Virgin Islands" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
  { value: "AB", label: "Alberta" },
  { value: "BC", label: "British Columbia" },
  { value: "MB", label: "Manitoba" },
  { value: "NB", label: "New Brunswick" },
  { value: "NL", label: "Newfoundland and Labrador" },
  { value: "NT", label: "Northwest Territory" },
  { value: "NS", label: "Nova Scotia" },
  { value: "NU", label: "Nunavut" },
  { value: "ON", label: "Ontario" },
  { value: "PE", label: "Prince Edward Island" },
  { value: "QC", label: "Quebec" },
  { value: "SK", label: "Saskatchewan" },
  { value: "YT", label: "Yukon Territory" },
];
export const CityOptions = [
  { value: "New York", label: "New York" },
  { value: "Los Angeles", label: "Los Angeles" },
  { value: "Chicago", label: "Chicago" },
  { value: "Houston", label: "Houston" },
];

export const cityOptionsCanada=["Banff", "Brooks", "Calgary", "Edmonton", "Fort McMurray", "Grande Prairie", "Jasper", "Lake Louise", "Lethbridge", "Medicine Hat", "Red Deer", "Saint Albert", "Barkerville", "Burnaby", "Campbell River", "Chilliwack", "Courtenay", "Cranbrook", "Dawson Creek", "Delta", "Esquimalt", "Fort Saint James", "Fort Saint John", "Hope", "Kamloops", "Kelowna", "Kimberley", "Kitimat", "Langley", "Nanaimo", "Nelson", "New Westminster", "North Vancouver", "Oak Bay", "Penticton", "Powell River", "Prince George", "Prince Rupert", "Quesnel", "Revelstoke", "Rossland", "Trail", "Vancouver", "Vernon", "Victoria", "West Vancouver", "White Rock", "Brandon", "Churchill", "Dauphin", "Flin Flon", "Kildonan", "Saint Boniface", "Swan River", "Thompson", "Winnipeg", "York Factory", "Bathurst", "Caraquet", "Dalhousie", "Fredericton", "Miramichi", "Moncton", "Saint John", "Argentia", "Bonavista", "Channel-Port aux Basques", "Corner Brook", "Ferryland", "Gander", "Grand Falls–Windsor", "Happy Valley–Goose Bay", "Harbour Grace", "Labrador City", "Placentia", "Saint Anthony", "St. John’s", "Wabana", "Fort Smith", "Hay River", "Inuvik", "Tuktoyaktuk", "Yellowknife", "Baddeck", "Digby", "Glace Bay", "Halifax", "Liverpool", "Louisbourg", "Lunenburg", "Pictou", "Port Hawkesbury", "Springhill", "Sydney", "Yarmouth", "Iqaluit", "Bancroft", "Barrie", "Belleville", "Brampton", "Brantford", "Brockville", "Burlington", "Cambridge", "Chatham", "Chatham-Kent", "Cornwall", "Elliot Lake", "Etobicoke", "Fort Erie", "Fort Frances", "Gananoque", "Guelph", "Hamilton", "Iroquois Falls", "Kapuskasing", "Kawartha Lakes", "Kenora", "Kingston", "Kirkland Lake", "Kitchener", "Laurentian Hills", "London", "Midland", "Mississauga", "Moose Factory", "Moosonee", "Niagara Falls", "Niagara-on-the-Lake", "North Bay", "North York", "Oakville", "Orillia", "Oshawa", "Ottawa", "Parry Sound", "Perth", "Peterborough", "Picton", "Port Colborne", "Saint Catharines", "Saint Thomas", "Sarnia-Clearwater", "Sault Sainte Marie", "Scarborough", "Simcoe", "Stratford", "Sudbury", "Temiskaming Shores", "Thorold", "Thunder Bay", "Timmins", "Toronto", "Trenton", "Waterloo", "Welland", "West Nipissing", "Windsor", "Woodstock", "York", "Borden", "Cavendish", "Charlottetown", "Souris", "Summerside", "Asbestos", "Baie-Comeau", "Beloeil", "Cap-de-la-Madeleine", "Chambly", "Charlesbourg", "Châteauguay", "Chibougamau", "Côte-Saint-Luc", "Dorval", "Gaspé", "Gatineau", "Granby", "Havre-Saint-Pierre", "Hull", "Jonquière", "Kuujjuaq", "La Salle", "La Tuque", "Lachine", "Laval", "Lévis", "Longueuil", "Magog", "Matane", "Montreal", "Montréal-Nord", "Percé", "Port-Cartier", "Quebec", "Rimouski", "Rouyn-Noranda", "Saguenay", "Saint-Eustache", "Saint-Hubert", "Sainte-Anne-de-Beaupré", "Sainte-Foy", "Sainte-Thérèse", "Sept-Îles", "Sherbrooke", "Sorel-Tracy", "Trois-Rivières", "Val-d’Or", "Waskaganish", "Batoche", "Cumberland House", "Estevan", "Flin Flon", "Moose Jaw", "Prince Albert", "Regina", "Saskatoon", "Uranium City", "Dawson", "Watson Lake", "Whitehorse"]

export async function getTerminalsId() {
  HTTP("get", "carrier/terminal-ids").then((result) => {
    if (result.data.statusCode === 200) {
      let response = result.data.data
      setStorage('idForTerminal', response && response.length > 0 && response[0].idForTerminal);
      config.idForTerminal = response && response.length > 0 && response[0].idForTerminal
    }
  });
}

export async function getCustomReportIds() {
  HTTP("get", "carrier/custom-report-ids").then((result) => {
    if (result.data.statusCode === 200) {
      let response = result.data.data
      setStorage('idForCustomChargeReport', response && response.length > 0 && response[0].idForCustomChargeReport);
      config.idForCustomChargeReport = response && response.length > 0 && response[0].idForCustomChargeReport
    }
  });
}

export async function editTMSCustomer(data) {
  let url = "carrier/editTMSCustomer"
  const token = getStorage('token')
  const response = await HTTP('post', url, data, {
    authorization: token
  })
  return response;
}